import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.leftArrow = this.element.querySelector('.horizontal-menu__arrow.left');
    this.rightArrow = this.element.querySelector('.horizontal-menu__arrow.right');
    this.wrapper = this.element.querySelector('.horizontal-menu');

    this.isDown = false;
    this.isTouchingArrow = false;
    this.scrollAmount = 200;
    this.scrollInterval = null;

    this.bind();
    this.update();
  }

  bind() {
    this.wrapper.addEventListener('scroll', () => this.update());

    this.wrapper.addEventListener('touchstart', (e) => {
      if (!this.isTouchingArrow) {
        this.element.style.pointerEvents = 'auto'; // Enable interaction with menu if not touching arrows
      }
    });

    if (!this.leftArrow || !this.rightArrow) return;

    // Left

    this.leftArrow.addEventListener('mousedown', () => this.startScrolling('left'));
    this.leftArrow.addEventListener('mouseleave', () => this.stopScrolling());
    this.leftArrow.addEventListener('mouseup', () => this.stopScrolling());

    this.leftArrow.addEventListener('touchstart', () => {
      this.isTouchingArrow = true;

      this.startScrolling('left');

      this.element.style.pointerEvents = 'none'; // Disable interaction with menu
    });

    this.leftArrow.addEventListener('touchend', () => {
      this.stopScrolling();

      this.element.style.pointerEvents = 'auto'; // Restore interaction with menu

      this.isTouchingArrow = false;
    });

    this.leftArrow.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();

      this.startScrolling('left');
    });

    this.leftArrow.addEventListener('keyup', () => this.stopScrolling());

    // Right

    this.rightArrow.addEventListener('mousedown', () => this.startScrolling('right'));
    this.rightArrow.addEventListener('mouseleave', () => this.stopScrolling());
    this.rightArrow.addEventListener('mouseup', () => this.stopScrolling());

    this.rightArrow.addEventListener('touchstart', () => {
      this.isTouchingArrow = true;

      this.startScrolling('right');

      this.element.style.pointerEvents = 'none'; // Disable interaction with menu
    });

    this.rightArrow.addEventListener('touchend', () => {
      this.stopScrolling();

      this.element.style.pointerEvents = 'auto'; // Restore interaction with menu

      this.isTouchingArrow = false;
    });

    this.rightArrow.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();

      this.startScrolling('right');
    });

    this.rightArrow.addEventListener('keyup', () => this.stopScrolling());
  }

  startScrolling(direction) {
    this.stopScrolling();

    this.scrollInterval = setInterval(() => {
      this.wrapper.scrollLeft += direction === 'left' ? -this.scrollAmount : this.scrollAmount;
    }, 16);
  }

  stopScrolling() {
    clearInterval(this.scrollInterval);
  }

  update() {
    const scrollLeft = this.wrapper.scrollLeft;
    const clientWidth = this.wrapper.clientWidth;
    const scrollWidth = this.wrapper.scrollWidth;

    this.element.classList.toggle('show-left', scrollLeft > 0);
    this.element.classList.toggle('show-right', scrollLeft + clientWidth < scrollWidth - 1);
  }
}
